import { AdjustmentEffectiveness } from './adjustment-effectiveness';

export class AdjustmentSummary {
  adjustmentSummaryId: number;
  unadjustedRangeValue: number;
  adjustedRangeValue: number;
  adjustmentEffectiveness: AdjustmentEffectiveness = new AdjustmentEffectiveness();
}
